import { FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE } from "../Constants";

export const ForgotPassword = (payload) => ({
    type: FORGOT_PASSWORD,
    payload
});

export const ForgotPasswordSuccess = (payload) => ({
    type: FORGOT_PASSWORD_SUCCESS,
    payload
});

export const ForgotPasswordFailure = (payload) => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload
});